import request from '@/utils/request'
/**
 * 获取收藏学习课程
 * @param {Object} data 
 * @returns 
 */
export function getstudyCourse (data) {
    return request({
        url: '/userDataStatistics/getstudyCourse',
        method: 'POST',
        data
    })
}
